// import React from 'react'
// import appMessages from './appMessages.json'




export const getLabelsObject = (type, appMessages ) => {

    if(type === 'create-kids-pin') return {
        
        "title": appMessages.label_profile_popup_create_kids_pin_popup_title,
        "description": appMessages.label_profile_popup_create_kids_pin_popup_description,
        "validationErrorText": appMessages.label_profile_popup_create_kids_pin_popup_only_number_warning,
        "positiveButtonText": appMessages.label_profile_popup_create_kids_pin_popup_button_next,
        "negativeButtonText": appMessages.label_profile_popup_create_kids_pin_popup_button_cancel

        }
    else if (type === 'create-kids-pin-confirm') return {
        "title": appMessages.label_profile_popup_new_kids_pin_confirm_popup_title,
        "description": appMessages.label_profile_popup_new_kids_pin_confirm_popup_description,
        "positiveButtonText": appMessages.label_profile_popup_new_kids_pin_confirm_popup_button_done,
        "negativeButtonText": appMessages.label_profile_popup_new_kids_pin_confirm_popup_button_cancel
    }
    else if (type === 'change-pin-enter-new-pin-confirm') return {
        "title": appMessages.label_profile_popup_new_kids_pin_confirm_popup_title,
        "description": appMessages.label_profile_popup_new_kids_pin_confirm_popup_description,
        "positiveButtonText": appMessages.label_profile_popup_new_kids_pin_confirm_popup_button_done,
        "negativeButtonText": appMessages.label_profile_popup_new_kids_pin_confirm_popup_button_cancel
    }
    else if (type === 'verify-kids-pin-for-exit') return {
        "title": appMessages.label_profile_popup_exit_kids_popup_title,
        "description": appMessages.label_profile_popup_exit_kids_popup_description,
        "positiveButtonText": appMessages.label_profile_popup_exit_kids_popup_button_done,
        "negativeButtonText": appMessages.label_profile_popup_exit_kids_popup_button_cancel
    }
    else if (type === 'change-pin-enter-existing-pin') return {
        "title": appMessages.label_profile_popup_verify_pin_popup_title,
        "description": appMessages.label_profile_popup_verify_pin_popup_description,
        "positiveButtonText": appMessages.label_profile_popup_verify_pin_popup_button_next,
        "negativeButtonText": appMessages.label_profile_popup_verify_pin_popup_button_cancel
    }
    else if (type === 'change-pin-enter-new-pin') return {
        "title": appMessages.label_profile_popup_change_pin_popup_title,
        "description": appMessages.label_profile_popup_change_pin_popup_description,
        "positiveButtonText": appMessages.label_profile_popup_change_pin_popup_button_done,
        "negativeButtonText": appMessages.label_profile_popup_change_pin_popup_button_cancel
    }
    else if (type === 'pin-changed-message') return {
        "title": appMessages.label_profile_popup_change_pin_confirmation_popup_title,
        "description": appMessages.label_profile_popup_change_pin_confirmation_popup_description,
        "singleButtonText": appMessages.label_profile_popup_change_pin_confirmation_popup_button_ok,
    }
    else if (type === 'maximum-profiles-reached') return {
        "title": appMessages.label_profile_popup_max_profiles_popup_title,
        "description": appMessages.label_profile_popup_max_profiles_popup_description,
        "singleButtonText": appMessages.label_profile_popup_max_profiles_popup_button_ok,
    }
    else if (type === 'do-you-want-pin-reset') return{
        "title": appMessages.label_profile_popup_wrong_pin_popup_title,
        "description": appMessages.label_profile_popup_wrong_pin_popup_description,
        "positiveButtonText": appMessages.label_profile_popup_wrong_pin_popup_button_cancel,
        "negativeButtonText": appMessages.label_profile_popup_wrong_pin_popup_button_confirm
    }
    else if (type === 'forgot-pin-login-confirmation') return{
        "title": appMessages.label_profile_popup_forgot_pin_popup_title,
        "description": appMessages.label_profile_popup_forgot_pin_popup_description,
        "positiveButtonText": appMessages.label_profile_popup_forgot_pin_popup_button_cancel,
        "negativeButtonText": appMessages.label_profile_popup_forgot_pin_popup_button_reset
    } 
    else if (type === 'kids-pin-created-succesfully') return{
        "title": appMessages.label_profile_popup_new_pin_created_popup_title,
        "description": appMessages.label_profile_popup_new_pin_created_popup_description,
        "singleButtonText": appMessages.label_profile_popup_new_pin_created_popup_button_ok
    }
   
}
